import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { ProjectSettingService } from 'src/app/pages/projects/services/project-setting.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';

@Component({
  selector: 'app-bug-modal',
  templateUrl: './bug-modal.component.html',
  styleUrls: ['./bug-modal.component.scss']
})
export class BugModalComponent implements OnInit {

  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  projectId: number | null = null;
  modalTitle: string;

  bugForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = true;
  bugType: string | null;
  labelInput: string;
  errorInput: string;

  constructor(protected settingSrv: SettingsPageService,
    protected projSettingSrv: ProjectSettingService,
    protected modalService: NgbModal,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected utilSrv: UtilsService) {
  }

  ngOnInit(): void {
    this.setForm();
  }

  get formBug() { return this.bugForm.controls; }

  setFormStructure() {
    switch (this.bugType) {
      case 'SEVERITY': {
        this.labelInput = 'SETTINGS.BUG.SEVERITY';
        this.errorInput = 'SETTINGS.BUG.SEVERITYREQUIRED';
        break;
      }
      case 'ISSUE': {
        this.labelInput = 'SETTINGS.BUG.ISSUE';
        this.errorInput = 'SETTINGS.BUG.ISSUEREQUIRED';
        break;
      }
      case 'BUG_ORIGIN': {
        this.labelInput = 'SETTINGS.BUG.ORIGIN';
        this.errorInput = 'SETTINGS.BUG.ORIGINREQUIRED';
        break;
      }
      default: {
        this.labelInput = '';
        this.errorInput = '';
        break;
      }
    }
  }

  setForm() {
    this.bugForm = this.fb.group({
      En: ['', Validators.required],
      Id: [0],
    });
  }

  setBugType(type: string) {
    this.bugType = type.includes('Severity') ? 'SEVERITY' : type.includes('Issue') ?
      'ISSUE' : type.includes('Origin') ? 'BUG_ORIGIN' : null;
  }

  setModalTitle(type: string) {
    this.modalTitle = type === 'addSeverity' ? 'SETTINGS.BUG.ADDSEVERITY' : type === 'editSeverity' ? 'SETTINGS.BUG.EDITSEVERITY' :
      type === 'addIssue' ? 'SETTINGS.BUG.ADDISSUE' : type === 'editIssue' ? 'SETTINGS.BUG.EDITISSUE' : type === 'addOrigin' ?
        'SETTINGS.BUG.ADDORIGIN' : type === 'editOrigin' ? 'SETTINGS.BUG.EDITORIGIN' : 'SETTINGS.COLLAPSE.BUG';
  }

  openModal(type: string, data: any, projectId?: number) {
    this.loading = true;
    this.setForm();

    if (projectId) this.projectId = projectId;
    this.setBugType(type);
    this.setModalTitle(type);
    this.setFormStructure();

    if (type.includes('edit')) this.fillForm(data);
    else this.loading = false;
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fillForm(data: any) {

    this.bugForm.controls['Id'].setValue(data.id);
    this.bugForm.controls['En'].setValue(data.description);

    this.loading = false;
  }

  save() {
    this.submitted = true;
    if (this.bugForm.valid) {
      const data: any = {
        type: this.bugType,
        description: this.formBug.En.value,
      }

      if (this.projectId) {
        data['projectId'] = this.projectId;
      }

      const id = this.formBug.Id.value;
      let request;
      if (this.projectId) {
        request = id === 0 ? this.projSettingSrv.createConfig(this.projectId, data) : this.projSettingSrv.updateConfig(this.projectId, id, data);
      } else request = id === 0 ? this.settingSrv.registerConfigurations(data) : this.settingSrv.updateConfiguration(data, id);

      request.pipe(finalize(() => {
        this.setForm();
        this.submitted = false;
      })).subscribe((data: any) => {
        const successMsg = id === 0 ? 'SETTINGS.CREATED' : 'SETTINGS.UPDATED';
        this.utilSrv.notify(successMsg, 'success').then(() => {
          this.modalRef.close();
          this.updateTable.emit();
        });
      }, (error: any) => {
        console.error('Save', error);
        this.utilSrv.notify('SETTINGS.ERROR', 'error');
      });
    } 
  }

  closeModal() {
    this.submitted = false;
    this.bugForm.reset();
    this.modalRef.close();
  }

}
